import React from "react";

const IndustryInfoSection = () => (
  <section className="industry-info-section">
    <div className="industry-info-container">
      <h2 className="industry-heading">
        Unleash the Power of Industry 4.0 in Your Classroom!
      </h2>
      <p className="industry-description">
        Transform traditional learning environments into dynamic, hands-on
        experiences that bring smart manufacturing to life. By integrating
        Industry 4.0 technologies like automation, IoT, and robotics into the
        curriculum, students gain real-world skills that prepare them for the
        future of work in modern industry.
      </p>
    </div>
  </section>
);

export default IndustryInfoSection;
